var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCluvaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2413 7.24139L19.5539 14.5945C19.4185 14.7241 19.2043 14.7217 19.0718 14.5891L6.20679 1.72415",
    stroke: "#050505",
    strokeWidth: 3.44828,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3781 27.3837L24.403 19.8041C24.1491 19.5282 24.1621 19.1001 24.4323 18.8401L37.3 6.45956",
    stroke: "#050505",
    strokeWidth: 3.44828,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5621 32.1475L19.142 24.6837C19.2755 24.5522 19.4897 24.5515 19.6242 24.6821L32.6743 37.3592",
    stroke: "#050505",
    strokeWidth: 3.44828,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.40608 11.7675L14.6987 19.5122C14.8272 19.6487 14.8231 19.8628 14.6895 19.9944L1.72412 32.7581",
    stroke: "#050505",
    strokeWidth: 3.44828,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCluvaLogo);
export default __webpack_public_path__ + "static/media/Cluva_logo.5d23999570fe3ec8343fd02263d21449.svg";
export { ForwardRef as ReactComponent };